export default __webpack_public_path__ + "static/media/Dial_Green.cf40fc73.png";